import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { useToast } from "@/hooks/use-toast";
import { useState } from "react";

const HelpSupport = () => {
  const { toast } = useToast();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Simulate submission
    setTimeout(() => {
      setIsSubmitting(false);
      toast({
        title: "Ticket Submitted",
        description: "We'll get back to you as soon as possible."
      });
    }, 1000);
  };

  return (
    <div className="min-h-screen bg-background pb-16">
      <main className="container mx-auto px-4 py-6 space-y-6">
        <Card className="p-6">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="space-y-4">
              <div>
                <Label htmlFor="subject">Subject</Label>
                <Input id="subject" placeholder="What do you need help with?" required />
              </div>

              <div>
                <Label htmlFor="message">Message</Label>
                <Textarea id="message" placeholder="Describe your issue or concern..." className="min-h-[150px]" required />
              </div>
            </div>

            <Button type="submit" className="w-full" disabled={isSubmitting}>
              {isSubmitting ? "Submitting..." : "Submit Ticket"}
            </Button>
          </form>
        </Card>

        <Card className="p-6">
          <h2 className="text-lg font-semibold mb-4">Frequently Asked Questions</h2>
          <div className="space-y-4">
            <div>
              <h3 className="font-medium">Have the chefs been vetted?</h3>
              <p className="text-sm text-muted-foreground">Yes! Every chef goes through a verification process to ensure they have a clean kitchen and proper food handling skills. You can view information about each chef specialities on their profile page. </p>
            </div>
            <div>
              <h3 className="font-medium">What if I have food allergies or dietary restrictions?</h3>
              <p className="text-sm text-muted-foreground">Each listing includes a comprehensive list of ingredients, allergens, and dietary considerations (i.e. gluten-free, dairy-free, vegan, etc). You can view this information on the listing page. In addition, chefs provide information about their kitchen (if they have pets in the home, if they have a dairy-free kitchen, etc) on their profile page. </p>
            </div>
            <div>
              <h3 className="font-medium">How do I become a Chef?</h3>
              <p className="text-sm text-muted-foreground">Visit your profile page and click on "Become a Chef" to start the process.</p>
            </div>
          </div>
        </Card>
      </main>
    </div>
  );
};

export default HelpSupport;
